"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
var Tab_1 = __importDefault(require("@material-ui/core/Tab"));
var core_1 = require("@material-ui/core");
var Navigation_css_1 = __importDefault(require("./Navigation-css"));
var Navigation = function (props) {
    var internalClasses = Navigation_css_1.default(core_1.useTheme());
    var _a = react_1.useState(props.navs.findIndex(function (nav) {
        var _a;
        return (nav.link || "").split("?")[0] === ((_a = props.location) === null || _a === void 0 ? void 0 : _a.pathname) ||
            (nav.children || []).some(function (child) { var _a; return (child.link || "").split("?")[0] === ((_a = props.location) === null || _a === void 0 ? void 0 : _a.pathname); });
    }) || 0), selected = _a[0], setSelected = _a[1];
    var _b = react_1.useState([]), children = _b[0], setChildren = _b[1];
    var _c = react_1.useState(null), parent = _c[0], setParent = _c[1];
    var _d = react_1.useState(null), parentIndex = _d[0], setParentIndex = _d[1];
    var handleClose = function () {
        setParent(null);
    };
    return (react_1.default.createElement("div", { style: __assign({}, internalClasses[props.dense
            ? "invosys-ui-Navigation-navContainer-dense"
            : "invosys-ui-Navigation-navContainer"]) },
        react_1.default.createElement(Tabs_1.default, { indicatorColor: "primary", centered: true, onChange: function (event, value) {
                setSelected(value);
                if (props.changeCallback) {
                    props.changeCallback(event, value);
                }
            }, value: Math.floor(selected) }, props.navs.map(function (nav, index) { return (react_1.default.createElement(Tab_1.default, { style: __assign(__assign({}, internalClasses["invosys-ui-Navigation-tab"]), (nav.style || {})), className: "invosys-ui-Navigation-tab-" + index, key: index, icon: nav.icon, label: react_1.default.createElement(Typography_1.default, { variant: "subtitle2" }, nav.label || nav.link), value: index, component: nav.component || props.component || core_1.Button, to: nav.link, disabled: nav.disabled, onClick: function () {
                if (nav.children) {
                    setChildren(nav.children);
                    setParent(document.querySelector(".invosys-ui-Navigation-tab-" + index));
                    setParentIndex(index);
                }
                if (nav.action) {
                    nav.action();
                }
            } })); })),
        !!children && (react_1.default.createElement(core_1.Popover, { open: Boolean(parent), anchorEl: parent, onClose: handleClose, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left"
            } },
            react_1.default.createElement(core_1.List, { onMouseLeave: function () {
                    setParent(null);
                } }, children.map(function (child, idx) { return (react_1.default.createElement(core_1.ListItem, { component: child.component || props.component || core_1.Button, style: child.style, key: idx + 1, to: child.link, selected: selected === parseFloat(parentIndex + "." + (idx + 1), 10), onClick: function () {
                    setSelected(parseFloat(parentIndex + "." + (idx + 1), 10));
                    if (child.action) {
                        child.action();
                    }
                } },
                react_1.default.createElement(Typography_1.default, { color: "textPrimary" }, child.label),
                !!child.icon && (react_1.default.createElement(core_1.ListItemIcon, { style: { justifyContent: "flex-end" } }, child.icon)))); }))))));
};
exports.default = Navigation;
Navigation.propTypes = {
    navs: prop_types_1.default.array,
    location: prop_types_1.default.object,
    changeCallback: prop_types_1.default.func,
    theme: prop_types_1.default.object,
    component: prop_types_1.default.any,
    dense: prop_types_1.default.bool
};
